import { Link, useLocation } from "react-router-dom";
import Layout from "@/components/feature/Layout";
import PageMeta from "@/components/feature/PageMeta";
import PosterGrid from "@/components/base/PosterGrid";
import { getHot } from "@/utils/catalog";

export default function NotFound() {
  const location = useLocation();
  const hotPicks = getHot(6);

  return (
    <Layout>
      <PageMeta
        title="页面不存在 - 中文字幕在线免费看"
        description="你访问的页面不存在或已被移动，请返回首页，或从热门影视推荐与分类频道继续浏览中文字幕电影和电视剧。"
      />

      <section className="relative overflow-hidden bg-primary-950 px-4 py-14 md:px-8 md:py-20">
        <div className="pointer-events-none absolute inset-0 bg-gradient-to-br from-primary-900 via-primary-950 to-primary-950"></div>
        <div className="relative flex flex-col items-center text-center">
          <p className="font-heading text-6xl font-semibold text-accent-500/90 md:text-8xl">404</p>
          <h1 className="mt-4 font-heading text-2xl font-semibold text-background-50 md:text-3xl">
            页面不存在
          </h1>
          <p className="mt-3 max-w-[520px] text-[13px] leading-7 text-background-300">
            你访问的地址 <span className="break-all text-accent-300">{location.pathname}</span> 没有对应内容，可能链接输入有误，或页面已经调整。
          </p>
          <div className="mt-6 flex flex-wrap justify-center gap-2.5">
            <Link
              to="/"
              className="flex cursor-pointer items-center gap-1.5 whitespace-nowrap rounded-md bg-accent-500 px-5 py-2.5 text-sm font-semibold text-primary-950 transition-colors hover:bg-accent-400"
            >
              <i className="ri-home-5-line text-base" aria-hidden="true"></i>
              返回首页
            </Link>
            <Link
              to="/category/movie"
              className="cursor-pointer whitespace-nowrap rounded-md border border-background-50/30 px-5 py-2.5 text-sm text-background-100 transition-colors hover:border-accent-400 hover:text-accent-300"
            >
              浏览电影频道
            </Link>
            <Link
              to="/category/tv"
              className="cursor-pointer whitespace-nowrap rounded-md border border-background-50/30 px-5 py-2.5 text-sm text-background-100 transition-colors hover:border-accent-400 hover:text-accent-300"
            >
              浏览电视剧频道
            </Link>
          </div>
        </div>
      </section>

      <section className="px-4 py-10 md:px-8 md:py-12">
        <div className="mb-5 flex flex-wrap items-end justify-between gap-2">
          <h2 className="flex items-center gap-2.5 font-heading text-lg font-semibold text-foreground-950 md:text-xl">
            <span className="h-5 w-1.5 rounded-full bg-accent-500"></span>
            不如看看这些热门作品
          </h2>
          <Link to="/search?q=悬疑" className="cursor-pointer whitespace-nowrap text-xs text-foreground-600 transition-colors hover:text-primary-700">
            搜索悬疑片单
          </Link>
        </div>
        <PosterGrid items={hotPicks} />
      </section>
    </Layout>
  );
}